import React from "react";
import { Link } from "react-router-dom";
import { INDUSTRIES } from "../lib/content";
import { Reveal } from "../components/ui-bits";
import SEO from "../components/SEO";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <SEO
        title="Industries"
        description="HidroVerse engineers water systems for seven commercial sectors. Pick the one that matches your site to see the typical stack, timeline and standards."
        path="/industries"
      />

      {/* HERO — dark band, brief */}
      <section
        className="px-6 md:px-12 lg:px-20 pt-36 pb-20 md:pb-24"
        style={{ background: "#070A0D", color: "#F5F7FA" }}
      >
        <div className="max-w-[1400px] mx-auto">
          <div
            className="font-mono uppercase mb-5"
            style={{ fontSize: "0.62rem", letterSpacing: "0.28em", color: "#1FB6C1" }}
          >
            Industries
          </div>
          <h1
            className="font-display"
            style={{
              fontSize: "clamp(2.2rem, 6vw, 5.2rem)",
              lineHeight: 1.06,
              letterSpacing: "-0.025em",
              fontWeight: 300,
              maxWidth: "18ch",
            }}
          >
            The industries<br />
            <span style={{ color: "#1FB6C1", fontWeight: 600 }}>we serve.</span>
          </h1>
          <p
            className="mt-8 max-w-2xl font-light"
            style={{ fontSize: "1rem", color: "#9AA7B4", lineHeight: 1.6 }}
          >
            Every sector has its own water reality — its own feed-water, its own regulator,
            its own definition of failure. Pick yours and we'll show you the stack we deploy,
            the standards we hit, and the typical timeline from survey to commissioning.
          </p>
        </div>
      </section>

      {/* INDUSTRY TILES — warm white, photo cards */}
      <section
        className="px-6 md:px-12 lg:px-20 py-14 md:py-20"
        style={{ background: "#FAFAF7" }}
      >
        <div className="max-w-[1500px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.slug} delay={i * 60}>
              <Link
                to={`/industries/${ind.slug}`}
                className="industry-tile block aspect-[16/10]"
                data-testid={`industry-card-${ind.slug}`}
              >
                <img src={ind.hero} alt={ind.name} loading="lazy" />
                <div className="tile-overlay" />
                <div className="tile-label">
                  <div>
                    <div
                      className="font-mono uppercase mb-2"
                      style={{ fontSize: "0.6rem", letterSpacing: "0.22em", color: "rgba(255,255,255,0.85)" }}
                    >
                      Industry
                    </div>
                    <div
                      className="font-industrial text-white"
                      style={{ fontSize: "1.25rem", lineHeight: 1.2, letterSpacing: "-0.01em", maxWidth: "24ch" }}
                    >
                      {ind.name}
                    </div>
                    <div
                      className="mt-2 font-light text-white/85"
                      style={{ fontSize: "0.9rem", lineHeight: 1.5, maxWidth: "44ch" }}
                    >
                      {ind.short}
                    </div>
                  </div>
                  <div className="self-end text-white/80 text-xl">→</div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
